import { Icon, IconProps } from '@chakra-ui/react'

export function SwapIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 24 19" {...props}>
      <path
        d="M5.32 8L0 13.3333L5.32 18.6667V14.6667H14.6667V12H5.32V8ZM24 5.33333L18.68 0V4H9.33333V6.66667H18.68V10.6667L24 5.33333Z"
        fill="currentColor"
      />
    </Icon>
  )
}
